// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect } from "react";
import { overwriteTranslations } from "@sequentech/ui-core";
var useUpdateTranslation = function (_a, defaultLanguageTouched, setDefaultLanguageTouched) {
    var electionEvent = _a.electionEvent;
    // Overwrites translations based on the election event presentation
    useEffect(function () {
        if (!(electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation)) {
            return;
        }
        var hasSetDefaultLanguage = overwriteTranslations(electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation, !defaultLanguageTouched);
        if (hasSetDefaultLanguage) {
            setDefaultLanguageTouched(true);
        }
    }, [electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation]);
    return {};
};
export default useUpdateTranslation;
